/**
 * @Author: panezhang
 * @Date: 2018/6/2-11:39
 * @Last Modified by: ruiwang
 * @Last Modified time: 2024-12-22 16:26:31
 */

/* eslint-disable no-underscore-dangle */

import Vue from 'vue';

import {createClientMixin as createHeadClientMixin} from '../ssr/feature/head';
import {hookReadyClientMixin} from '../ssr/feature/hook-ready';
import {registerComponentsStoreModules, mixin as storeModuleMixin} from '../ssr/feature/store-module';
import {createClientMixin as createTitleClientMixin} from '../ssr/feature/title';
import {fetchComponentsAsyncData, reuseServerState, mixin as asyncDataMixin} from './feature/async-data-enable-csr';

export const createClientEntry = ({createApp, rootTitle, el = '#app', noStageTitle, fallbackContext} = {}) => {
    let rootEl = el;
    const csrRootEl = '#csr-app';
    const csrRootDom = document.querySelector(csrRootEl);

    Vue.mixin(asyncDataMixin);
    Vue.mixin(createHeadClientMixin());
    Vue.mixin(hookReadyClientMixin);
    Vue.mixin(storeModuleMixin);
    Vue.mixin(createTitleClientMixin({rootTitle, noStageTitle}));

    const initialState = window.__INITIAL_STATE__ || {};
    if (csrRootDom) {
        rootEl = csrRootEl;
    }

    let context = initialState.$context;
    if (!context) {
        const guessLocale = navigator?.language || '';
        const {availibleLanguages, defaultLanguage, ...rest} = fallbackContext || {};
        if (availibleLanguages?.length) {
            const acceptLanguage = availibleLanguages.find(item => new RegExp(`^${item}`, 'i').test(guessLocale)) || defaultLanguage;

            context = {
                ...rest,
                acceptLanguage
            };
        }
    }

    context = context || {};

    try {
        delete initialState.$context;
    } catch (e) {
        /* handle error */
    }

    const {app, router, store} = createApp(context);

    router.onReady(() => {
        const matchedComponents = router.getMatchedComponents();
        registerComponentsStoreModules(store, matchedComponents);
        reuseServerState(store);

        // Add router hook for handling asyncData.
        // Doing it after initial route is resolved so that we don't double-fetch the data that we already have.
        // Using router.beforeResolve() so that all async components are resolved.
        router.beforeResolve((to, from, next) => {
            const matched = router.getMatchedComponents(to);

            // 是否重新获取数据，交由组件自己判断，有些组件确实需要重新获取
            // const prevMatched = router.getMatchedComponents(from);
            // let diffed = false;
            // const activated = matched.filter(
            //     (component, idx) => diffed || (diffed = (prevMatched[idx] !== component))
            // );

            registerComponentsStoreModules(store, matched);
            fetchComponentsAsyncData(store, to, [app.$options, ...matched]).then(() => next()).catch(next);
        });

        app.$mount(rootEl);
    });

    return {app, router, store, context};
};
